import React from 'react';
import { motion } from 'framer-motion';
import { Building2Icon, RadioTowerIcon, TrophyIcon, UsersRoundIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
const SECTORS = [{
  icon: TrophyIcon,
  name: 'Clubes y estadios deportivos',
  desc: 'Tecnología visual y producción para competencias, equipos y grandes audiencias.'
}, {
  icon: Building2Icon,
  name: 'Torres corporativas / oficinas',
  desc: 'Soluciones audiovisuales para espacios de trabajo y comunicación institucional.'
}, {
  icon: RadioTowerIcon,
  name: 'Canales y medios de transmisión',
  desc: 'Producción técnica, streaming y contenidos para audiencias en vivo.'
}, {
  icon: UsersRoundIcon,
  name: 'Eventos institucionales',
  desc: 'Experiencias visuales integrales para encuentros y comunicaciones de alto impacto.'
}];
export function Sectors() {
  return <section id="sectores" className="w-full bg-vm-sky py-28 lg:py-36" data-id="element-144" data-mp="36w253acnuihq">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-145" data-mp="l9p5gonlrgnn">
        <div className="max-w-4xl" data-id="element-146" data-mp="la7bgd02h98r">
          <SectionLabel data-id="element-147" data-mp="h83pgufrum98">Sectores</SectionLabel>
          <h2 className="mt-6 font-syne text-4xl font-bold leading-[1.03] text-vm-bg sm:text-5xl lg:text-[56px]" data-id="element-148" data-mp="h9f2zlz0r8dj">
            Trabajamos con empresas de todos los sectores
          </h2>
        </div>

        <div className="mt-14 grid gap-3 sm:grid-cols-2" data-id="element-149" data-mp="q80jzcouefc7">
          {SECTORS.map((sector, i) => {
          const Icon = sector.icon;
          return <motion.div key={sector.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i % 2 * 0.08
          }} className="group rounded-2xl border border-vm-bg bg-white p-8 transition-colors duration-300 hover:border-vm-electric lg:p-10" data-id="element-150" data-mp="1077snmkmtlsz" data-mpi={i}>
                <Icon className="h-9 w-9 text-vm-electric" strokeWidth={1.5} data-id="element-151" data-mp="1iz0qbuanbv71" />
                <h3 className="mt-6 font-syne text-2xl font-semibold text-vm-bg lg:text-[28px]" data-id="element-152" data-mp="1q1p0sp5s68rn">{sector.name}</h3>
                <p className="mt-3 text-base font-light leading-relaxed text-vm-navy" data-id="element-153" data-mp="1v0a3cv8i94j9">
                  {sector.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}